import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

export const CircularLoading: React.FC = () => {
    return <CircularProgress style={{ position: 'absolute', margin: 'auto', top: 0, left: 0, bottom: 0, right: 0 }}/>;
};
